module.exports = __webpack_public_path__ + "img/norway-liver-cancer-female.f3e7f79e.png";